import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TTSourceInput from './TTSourceInput';
import { updateSourceInputFieldData } from 'redux/translationTable/TranslationTableActions';

const mapStateToProps = ({ translationTable }, { sourceInput }) => ({
  sourceInputList: translationTable.lists.find(list => (list.sourceInputId === sourceInput.id))
});

const mapDispatchToProps = dispatch => ({
  ttActions: bindActionCreators({ updateSourceInputFieldData }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(TTSourceInput);



// WEBPACK FOOTER //
// ./src/shared/components/translationTable/c/ttRowManager/c/ttMainGrid/c/ttSourceInput/TTSourceInputConnector.js